import { Button, Col, Input, Modal, Row, Spin } from 'antd';
import Form, { FormComponentProps } from 'antd/lib/form';
import twoFactor from '../../../../static/image/two-factor.png';
import OtpInput from 'react-otp-input';
import React from 'react';
import '../../login.scss';

interface Confirm2FAProps extends FormComponentProps {
  loading: boolean;
  visible: boolean;
  hideModal: any;
  okModal: any;
  okLabel?: string
}

const Confirm2FA = (props: Confirm2FAProps) => {
  const { loading } = props;
  const { getFieldDecorator } = props.form;
  const isDisabledVerify = props.form.getFieldValue('code')
    ? props.form.getFieldValue('code').length == 6
      ? false
      : true
    : true;

  return (
    <Modal centered className="ant-modal-custom" visible={props.visible} closable={false} footer={null} destroyOnClose>
      <Spin spinning={loading}>
        <Row type="flex" align="middle" gutter={[20, 20]} style={{ flexDirection: 'column' }}>
          <Col xs={24} style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <div>
              <img alt="logo-two-factor" src={twoFactor} />
            </div>
            <p className="txt-black-color-90" style={{ fontSize: 24, opacity: '85%', marginBottom: 0 }}>
              Two-factor authentication
            </p>
            <p style={{ marginBottom: 0 }}>Open the Google Authenticator app on your device to view</p>
            <p style={{}}>your authentication code and verify your identity</p>
          </Col>
          <Col xs={24}>
            <Form
              layout="vertical"
              hideRequiredMark
              colon={false}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <Form.Item>
                {getFieldDecorator('code', {
                  rules: [
                    {
                      required: true,
                      message: 'Please enter the code',
                    },
                  ],
                })(
                  <Input
                    style={{ width: '100%', display: 'none' }}
                    placeholder="Open your authentication app and enter the code for ByteTech"
                  />
                )}
                <OtpInput
                  isInputNum
                  inputStyle={'inputStyle'}
                  focusStyle={{
                    outline: 'none',
                    color: 'var(--primary-color)',
                    border: '2px solid var(--primary-color)',
                  }}
                  value={props.form.getFieldValue('code')}
                  onChange={(otp: any) => {
                    props.form.setFieldsValue({ code: otp });
                    if (otp.length == 6) {
                      props.okModal(undefined, props.form);
                    }
                  }}
                  numInputs={6}
                  className="custom-style-otp"

                // separator={<span>-</span>}
                />
              </Form.Item>
            </Form>
          </Col>
          <Col style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%' }}>
            <Button style={{ flex: 1, color: 'black' }} onClick={props.hideModal}>
              Cancel
            </Button>
            <Button
              disabled={isDisabledVerify}
              type="primary"
              style={{ flex: 1 }}
              onClick={(e) => {
                props.okModal(e, props.form);
              }}
            >
              {props.okLabel || 'Verify'}
            </Button>
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
};

export const ModalConfirm2FA = Form.create<Confirm2FAProps>()(Confirm2FA);
